import { render, staticRenderFns } from "./LKMunMehCard.vue?vue&type=template&id=04fdd030&"
import script from "./LKMunMehCard.vue?vue&type=script&lang=js&"
export * from "./LKMunMehCard.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports